<template>
  <div class="page">

    <Loader v-if="loader" />

    <p>Elementi selezionati: {{totalSelectedItems}} su {{totalItems}}</p>

    <DataTable :value="data" v-model:selection="selectedItems" dataKey="id" responsiveLayout="scroll" >
      <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
      <Column field="code" header="Code"></Column>
      <Column field="tensione" header="Tensione"></Column>
      <Column field="cliente" header="Cliente"></Column>
      <Column field="codfis" header="C.f."></Column>
      <Column field="piva" header="P.iva"></Column>
      <Column field="stato" header="Stato"></Column>
    </DataTable>

  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>
</template>

<script>
import Service from '@/services/ask-operation/operation-service'
import Loader from '@/components/Loader.vue'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  
  components: {
     Loader
  },

  data() {
    return {
      loader: false,
      page:{
        name: 'pods-switch-in',
      },

      internalData: this.data,
      selectedItems: this.data
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
  },


  methods:{
    onOkButton(){
      //console.log(this.data)
      if (Object.entries(this.selectedItems).length !== 0) {
        this.loader = true
        this.service.createCsvSwitchIn(this.data)
        .finally(()=>{
          this.loader = false
          this._reset()
          
        })
      }else{
        this._reset()
        
      }
    },

    onCancelButton(){
      this._reset()
      this.$eventBus.emit('dialog-return-cancel-button', {})
    },
    _reset(){
      this.internalData = {}
    }
  },
  computed: {
    totalItems() {
      return this.internalData.length
    },
    totalSelectedItems() {
      return this.selectedItems.length
    }
  }

}
</script>

<style scoped>
  .p-chip.custom-chip {
    font-size: 13px;
    background: var(--primary-color);
    color: white;
    margin-right: 6px;
  }
</style>
